import { Validators } from '@angular/forms';
import { isDateBetweenInclusiveValidator } from '@co-3/ctrl-ui/forms';
import { Contract } from '@models/contract';
import { DamageReportValidatorConfig } from '@models/damage-report';

export const defaultDamageReportValidators: DamageReportValidatorConfig = {
    damageDate: (contract: Contract) => [
        Validators.required,
        isDateBetweenInclusiveValidator(contract.contractFrom, new Date(), 'dd.MM.yyyy'),
    ],
    location: [Validators.required],
    eventDescription: [],
    damageDescription: [Validators.required],
    notes: [],
};
